import React from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import axios from "axios";
import Link from "@material-ui/core/Link";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { DropzoneArea } from "material-ui-dropzone";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

import Tooltip from "@material-ui/core/Tooltip";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import LinearProgress from "@material-ui/core/LinearProgress";

import api from "../../common/api";

class PoliciesForm extends React.Component {
  state = {
    policyName: "",
    revitionCode: "",
    duedate: "",
    tasks: [],
    unexpected_situations: false,
    unexpected_situations_action_detail: "",
    disabled: false,
    contract_id: "",
    files: [],
    action: "",
    policyId: "",
    dialogOpen: false,
    disabled_submit: false,
    data: [],
    media: [],
    loading: true,
    tasks_to_delete: []
  };

  async componentDidMount() {
    await this.getTasks().then(result =>
      this.setState({
        data: result
      })
    );

    await this.setPolicyTasks();

    await this.setParams();
    this.setState({ loading: false });
  }

  setPolicyTasks = async () => {
    var tasks = [];
    var data = this.state.data;
    const token = localStorage.getItem("userToken");
    const result = await axios
      .get(api.categories().get("7"), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var promise = new Promise(function(resolve, reject) {
          resolve(res.data);
          res.data.map((val, idx) => {
            val.name = val.name.toUpperCase();
            if (
              val.name === "RENOVACIÓN DE VEHÍCULOS" ||
              val.name === "REPUESTOS ORIGINALES" ||
              val.name === "SERVICE TALLER OFICIAL"
            ) {
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "km",
                unit_id: "1",
                value: "",
                actionDetail: ""
              });
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "month",
                unit_id: "2",
                value: "",
                actionDetail: ""
              });
            } else if (val.name === "ESTACIONAMIENTO") {
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "drowpDownEstacionamiento",
                unit_id: "5",
                value: "",
                actionDetail: ""
              });
            } else if (val.name === "CANTIDAD LAVADOS AL MES") {
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "quantity",
                unit_id: "8",
                value: "",
                actionDetail: ""
              });
            } else if (val.name === "LAVADO") {
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "ammount",
                unit_id: "3",
                value: "",
                actionDetail: ""
              });
            } else {
              tasks.push({
                task_id: val.id,
                taskLabel: val.name,
                isSet: false,
                type: "",
                unit_id: "4",
                value: "",
                actionDetail: ""
              });
            }
            data.push({
              task_id: val.id,
              value: val.id,
              name: val.name,
              label: val.name,
              children: []
            });
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
    let tasksCopy = JSON.parse(JSON.stringify(this.state.tasks));
    tasksCopy = tasks;
    this.setState({ tasks: tasksCopy });
    //	this.setState({data: data})
  };

  setParams(location) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("idContract")) {
      this.setState({ action: "new" });
      this.setState({ contract_id: searchParams.get("idContract") });
      //    	this.setPolicyTasks();
    } else if (searchParams.get("idPolicy")) {
      this.setState({ action: "edit" });
      this.setState({ policyId: searchParams.get("idPolicy") });
      this.setPolicy(searchParams.get("idPolicy"));
    } else if (searchParams.get("vPolicy")) {
      this.setState({ action: "view" });
      this.setState({ tasks: [] });
      this.setState({ policyId: searchParams.get("vPolicy") });
      this.setPolicy(searchParams.get("vPolicy"));
      this.setState({ disabled: true });
    }
    return;
  }

  setPolicy(idPolicy) {
    var tasks = [];
    var policyTasks = [];
    var policyName: "";
    var description = "";
    var start_date = "";
    var duedate = "";
    var revitionCode = "";
    var budget_required = "";
    var budget_detailed = "";
    var budget_q = "";
    var unexpected_situations_action_detail = "";
    var contract_id = "";
    var media = [];

    let tasksCopy = JSON.parse(JSON.stringify(this.state.tasks));

    const result = this.getPolicy(idPolicy).then(result => {
      var promise = new Promise(function(resolve, reject) {
        resolve(result);
        policyName = result.name;
        description = result.description;
        unexpected_situations_action_detail = result.unexpected_situations;
        policyTasks = result.tasks;
        contract_id = result.contract ? result.contract.id : 0;
        duedate = result.due_date;
        start_date = result.start_date;
        revitionCode = result.revision_code;
        budget_q = result.budget_q;
        budget_detailed = result.budget_detailed;
        budget_required = result.budget_required;
        media = result.media;
        policyTasks.map((val, idx) => {
          tasksCopy = tasksCopy.filter(function(t) {
            return t.id !== val.task.task.id;
          });
          var taskCopyId = null;
          var i = 0;
          tasksCopy.map((val2, idx2) => {
            if (
              val2.task_id === val.task.task.id &&
              val2.unit_id === val.task.unit.id
            ) {
              taskCopyId = idx2;
              i++;
            }
          });
          //				val.task.unit.datatype = val.task.unit.datatype.toUpperCase()
          //				val.task.unit.name = val.task.unit.name.toUpperCase()
          if (val.task.unit.datatype === "BOOLEAN") {
            var type = "";
          } else if (val.task.unit.name === "KM") {
            var type = "km";
          } else if (val.task.unit.name === "MESES") {
            var type = "month";
          } else if (val.task.unit.name === "CANTIDAD") {
            var type = "quantity";
          } else if (val.task.unit.name === "MONTO") {
            var type = "ammount";
          }

          if (val.task.unit.datatype === "DROPDOWNESTACIONAMIENTO") {
            var type = "drowpDownEstacionamiento";
          }
          if (taskCopyId !== null && i === 1) {
            if (
              val.description === null ||
              val.description === undefined ||
              val.description === "null" ||
              val.description === "undefined"
            ) {
              val.description = "";
            }
            //					tasksCopy[taskCopyId]={policy_task_id: val.id, task_id:val.task.task.id, taskLabel:val.task.task.name, isSet:true, type:type, value:val.value,unit_id:val.task.unit.id, actionDetail:val.description}
            tasksCopy.push({
              policy_task_id: val.id,
              task_id: val.task.task.id,
              taskLabel: val.task.task.name,
              isSet: true,
              type: type,
              value: val.value,
              unit_id: val.task.unit.id,
              actionDetail: val.description
            });
          } else {
            tasksCopy.push({
              policy_task_id: val.id,
              task_id: val.task.task.id,
              taskLabel: val.task.task.name,
              isSet: true,
              type: type,
              value: val.value,
              unit_id: val.task.unit.id,
              actionDetail: val.description
            });
          }
        });
      });
      duedate = this.formatDate(duedate);
      start_date = this.formatDate(start_date);
      this.setState({ media: media });
      this.setState({ policyName: policyName });
      this.setState({ description: description });
      this.setState({ contract_id: contract_id });
      this.setState({ duedate: duedate });
      this.setState({ start_date: start_date });
      this.setState({ revitionCode: revitionCode });
      this.setState({ budget_detailed: budget_detailed });
      this.setState({ budget_required: budget_required });
      this.setState({ budget_q: budget_q });

      if (
        unexpected_situations_action_detail != "null" &&
        unexpected_situations_action_detail != null &&
        unexpected_situations_action_detail != ""
      ) {
        this.setState({
          unexpected_situations_action_detail: unexpected_situations_action_detail
        });
        this.setState({ unexpected_situations: true });
      } else {
        this.setState({ unexpected_situations_action_detail: "" });
        this.setState({ unexpected_situations: false });
      }
      tasksCopy.sort(function(x, y) {
        return x.isSet === y.isSet ? 0 : x.isSet ? -1 : 1;
      });
      this.setState({ tasks: tasksCopy });
    });
  }

  getPolicy = async idPolicy => {
    const token = localStorage.getItem("userToken");

    return await axios
      .get(api.policy().get(idPolicy), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  setDropdownTask(idx, e) {
    var res = idx.split("-");
    const section = res[0];
    const varName = res[1];
    const id = res[2];
    let tasks = [...this.state.tasks];
    tasks[id]["task_id"] = e.value;
    tasks[id]["taskLabel"] = e.label;
    this.setState({ tasks });
  }

  getTasks = () => {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.tasks, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        //	          this.setState({data: Object.values(res.data)})
        res.data = Object.values(res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  handlePreview = e => {
    let policyId = this.state.policyId;
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.policy().preview(policyId), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ errors: true });
        this.setState({ message: res.data });
        this.setState({ dialogOpen: true });
        return true;
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleSubmit = e => {
    this.setState({ disabled_submit: true });
    var tasks = [];
    var formData = new FormData();

    if (this.state.contract_id !== "0") {
      formData.set(
        "policy[contract_id]",
        this.state.contract_id !== "0" ? this.state.contract_id : ""
      );
    }
    formData.set("policy[name]", this.state.policyName);
    formData.set(
      "policy[description]",
      this.state.description ? this.state.description : ""
    );
    formData.set(
      "policy[unexpected_situations]",
      this.state.unexpected_situations_action_detail
        ? this.state.unexpected_situations_action_detail
        : ""
    );
    formData.set("policy[revision_code]", this.state.revitionCode);
    formData.set("policy[due_date]", this.state.duedate);
    formData.set(
      "policy[start_date]",
      this.state.start_date ? this.state.start_date : ""
    );

    formData.set(
      "policy[budget_required]",
      this.state.budget_required ? this.state.budget_required : 0
    );
    formData.set(
      "policy[budget_detailed]",
      this.state.budget_detailed ? this.state.budget_detailed : 0
    );
    formData.set(
      "policy[budget_q]",
      this.state.budget_q ? this.state.budget_q : 0
    );

    var i = 0;
    this.state.tasks.map((val, idx) => {
      if (val.isSet) {
        if (this.state.action === "edit" && val.policy_task_id != null) {
          formData.set("policy[tasks][" + i + "][id]", val.policy_task_id);
        }
        formData.set("policy[tasks][" + i + "][task_id]", val.task_id);
        formData.set("policy[tasks][" + i + "][unit_id]", val.unit_id);
        formData.set("policy[tasks][" + i + "][value]	", val.value);
        formData.set("policy[tasks][" + i + "][description]	", val.actionDetail);
        formData.set("policy[tasks][" + i + "][role_id]", 1);
        formData.set("policy[tasks][" + i + "][task_state_id]", 1);
        i++;
      } else {
        if (this.state.action === "edit" && val.policy_task_id != null) {
          formData.set("policy[tasks][" + i + "][task_id]", val.task_id);
          formData.set("policy[tasks][" + i + "][unit_id]", val.unit_id);
          formData.set("policy[tasks][" + i + "][value]	", val.value);
          formData.set(
            "policy[tasks][" + i + "][description]	",
            val.actionDetail
          );
          formData.set("policy[tasks][" + i + "][role_id]", 1);
          formData.set("policy[tasks][" + i + "][task_state_id]", 1);
          formData.set("policy[tasks][" + i + "][deleted_at]", Date.now());
          formData.set("policy[tasks][" + i + "][id]", val.policy_task_id);
        }
      }
    });

    this.state.tasks_to_delete.map((val, idx) => {
      if (val.isSet) {
        if (this.state.action === "edit" && val.policy_task_id != null) {
          formData.set("policy[tasks][" + i + "][id]", val.policy_task_id);
        }
        formData.set("policy[tasks][" + i + "][task_id]", val.task_id);
        formData.set("policy[tasks][" + i + "][unit_id]", val.unit_id);
        formData.set("policy[tasks][" + i + "][value]	", val.value);
        formData.set("policy[tasks][" + i + "][description]	", val.actionDetail);
        formData.set("policy[tasks][" + i + "][role_id]", 1);
        formData.set("policy[tasks][" + i + "][task_state_id]", 1);
        formData.set("policy[tasks][" + i + "][deleted_at]", Date.now());
        i++;
      }
    });
    if (i == 0) {
      formData.set("policy[tasks]", []);
    }

    this.state.files.map((val, idx) => {
      formData.append(`media[${idx}]`, val);
    });

    let self = this;
    const token = localStorage.getItem("userToken");

    if (this.state.action === "new") {
      axios
        .post(api.policy().post(this.state.contract_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false });
          self.setState({ message: "Politica creada con éxito!" });
          self.setState({ dialogOpen: true });
          self.setState({ disabled_submit: false });
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({
            message:
              "Faltan cargar los valores de las tareas. Por favor revisar."
          });
          self.setState({ dialogOpen: true });
          self.setState({ disabled_submit: false });
        });
    } else {
      formData.set("policy[id]", this.state.policyId);
      formData.append("_method", "patch");
      axios
        .post(api.policy().patch(this.state.policyId), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false });
          self.setState({ message: "Política modificada con éxito!" });
          self.setState({ dialogOpen: true });
          self.setState({ disabled_submit: false });
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({
            message:
              "Faltan cargar los valores de las tareas. Por favor revisar."
          });
          self.setState({ dialogOpen: true });
          self.setState({ disabled_submit: false });
        });
    }

    e.preventDefault();
  };

  handleUpload(files) {
    this.setState({
      files: files
    });
  }

  handleChangeForm = e => {
    var res = e.target.id.split("-");
    const varName = res[1];
    const id = res[2];

    if (e.target.id === "PolicyName") {
      this.setState({ policyName: e.target.value });
    }

    if (e.target.id === "description") {
      this.setState({ description: e.target.value });
    }
    if (e.target.id === "duedate") {
      this.setState({ duedate: e.target.value });
    }
    if (e.target.id === "start_date") {
      this.setState({ start_date: e.target.value });
    }

    if (e.target.id === "budget_q") {
      this.setState({ budget_q: e.target.value });
    }

    if (e.target.id === "budget_required") {
      this.setState({ budget_required: e.target.value });
    }

    if (e.target.id === "budget_detailed") {
      this.setState({ budget_detailed: e.target.value });
    }

    if (["value", "actionDetail"].includes(varName)) {
      let tasks = [...this.state.tasks];
      tasks[id][varName] = e.target.value;
      this.setState({ tasks });
    }

    if (e.target.id === "revitionCode") {
      this.setState({ revitionCode: e.target.value });
    }

    if (e.target.name === "drowpDownEstacionamiento") {
      let tasks = [...this.state.tasks];
      tasks[id][varName] = e.target.value;
      this.setState({ tasks });
    }

    if (["isSet"].includes(varName)) {
      let tasks = [...this.state.tasks];
      if (e.target.value === "true") {
        tasks[id][varName] = 0;
        if (tasks[id]["unit_id"] === "4") {
          tasks[id]["value"] = "0";
        }
      } else {
        if (
          [
            "SIEMPRE TALLER OFICIAL",
            "NUNCA TALLER OFICIAL",
            "TALLER OFICIAL HASTA CUMPLIR GARANTÍA DEL VEHÍCULO"
          ].includes(tasks[id]["taskLabel"])
        ) {
          tasks.map((val, id2) => {
            if (
              [
                "SIEMPRE TALLER OFICIAL",
                "NUNCA TALLER OFICIAL",
                "TALLER OFICIAL HASTA CUMPLIR GARANTÍA DEL VEHÍCULO"
              ].includes(val.taskLabel)
            ) {
              tasks[id2]["isSet"] = false;
              tasks[id2]["value"] = "1";
            }
          });
        }
        tasks[id][varName] = true;
        if (tasks[id]["unit_id"] === "4") {
          tasks[id]["value"] = "1";
        }
      }

      this.setState({ tasks });
    }

    if (e.target.id.includes("unexpected_situations")) {
      if (e.target.value === "true") {
        this.setState({ unexpected_situations: false });
      } else {
        this.setState({ unexpected_situations: true });
      }
    }

    if (e.target.id == "unexpected_situations_action_detail") {
      this.setState({ unexpected_situations_action_detail: e.target.value });
    }
  };

  addNewItem = e => {
    this.setState(prevState => ({
      tasks: [
        ...prevState.tasks,
        {
          task_id: "",
          taskLabel: "",
          isSet: false,
          type: "",
          value: "",
          unit_id: "4",
          actionDetail: ""
        }
      ]
    }));
  };

  removeItem = idx => () => {
    var task = this.state.tasks[idx];
    var tasks_to_delete = this.state.tasks_to_delete;
    tasks_to_delete.push(task);
    this.setState(prevState => ({
      tasks: [...prevState.tasks.filter((s, sidx) => idx !== sidx)]
    }));
    this.setState({ tasks_to_delete: tasks_to_delete });
  };

  formatDate(date) {
    if (date === "" || date === null || date === "null") {
      return null;
    }
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    let fromDate = new Date(date);
    let year = fromDate.getFullYear();

    let month = fromDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day =
      fromDate.getDate() < 10 ? "0" + fromDate.getDate() : fromDate.getDate();
    //return fromDate.getFullYear() + "-" + (fromDate.getMonth()+1) + "-" + fromDate.getDate();

    return year + "-" + month + "-" + day;
  }

  render() {
    const data = this.state.data;

    const handleDownload = id => () => {
      console.log(id);
    };

    const handleRedirect = id => () => {
      window.location.href = `/policies?idContract=${id}`;
    };

    const handleDialogClose = () => {
      this.setState({ dialogOpen: false });
    };

    let {
      policyName,
      revitionCode,
      duedate,
      budget_detailed,
      budget_required,
      budget_q,
      tasks,
      unexpected_situations,
      unexpected_situations_action_detail,
      disabled,
      media,
      description,
      start_date
    } = this.state;

    let budget_detailed_types = [
      { id: 1, name: "Si" },
      { id: 0, name: "No" }
    ];
    let budget_required_types = [
      { id: 1, name: "Si" },
      { id: 0, name: "No" }
    ];

    return this.state.loading ? (
      <LinearProgress />
    ) : (
      <form onSubmit={this.handleSubmit} onChange={this.handleChangeForm}>
        <Dialog
          open={this.state.dialogOpen}
          fullWidth
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Política de flota"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div
                dangerouslySetInnerHTML={{ __html: this.state.message }}
              ></div>
            </DialogContentText>
          </DialogContent>
          <DialogActions disableSpacing="false">
            {this.state.errors ? (
              <Button
                onClick={handleDialogClose}
                variant="contained"
                color="primary"
              >
                Aceptar
              </Button>
            ) : (
              <Button
                onClick={handleRedirect(this.state.contract_id)}
                variant="contained"
                color="primary"
              >
                Aceptar
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <TextField
          id="PolicyName"
          placeholder="Ingrese un nombre de politica de flota"
          label="Nombre de la política"
          required
          disabled={this.state.disabled}
          name="PolicyName"
          value={policyName}
          margin="normal"
          className="mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
        />
        <TextField
          id="description"
          placeholder="Ingrese una descripcion de politica de flota"
          label="Descripcion de la política"
          required
          disabled={this.state.disabled}
          name="description"
          value={description}
          margin="normal"
          className="mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
        />
        <TextField
          required
          id="revitionCode"
          placeholder="Ingrese el código de revisión"
          label="Código de revisión"
          name="revitionCode"
          value={revitionCode}
          disabled={this.state.disabled}
          margin="normal"
          className="mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
        />
        <TextField
          required
          id="start_date"
          label="Fecha de inicio"
          disabled={this.state.disabled}
          margin="normal"
          type="date"
          value={start_date}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          id="duedate"
          label="Fecha de vencimiento"
          disabled={this.state.disabled}
          margin="normal"
          type="date"
          value={duedate}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          InputLabelProps={{ shrink: true }}
        />

        <div>
          <Typography variant="h6" className="mt-2">
            Condición presupuestos
          </Typography>
          <FormControl className="mr-2 mt-1" inputProps={{ shrink: true }}>
            <Typography style={{ fontSize: "0.75rem" }}>
              Requiere presupuesto?
            </Typography>
            <Select
              native
              name="budget_required"
              id="budget_required"
              inputProps={{
                name: "budget_required",
                id: "budget_required",
                className: "budget_required"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              disabled={disabled}
              value={budget_required}
              input={
                <Input
                  id="grouped-native-select"
                  name="budget_required"
                  id="budget_required"
                />
              }
            >
              <option value="" />
              {budget_required_types.map(budget_required_type => (
                <option
                  id={budget_required_type.id}
                  value={budget_required_type.id}
                >
                  {budget_required_type.name}
                </option>
              ))}
            </Select>
          </FormControl>

          {budget_required === 1 || budget_required === "1" ? (
            <React.Fragment>
              <FormControl className="mr-2 mt-1" inputProps={{ shrink: true }}>
                <Typography style={{ fontSize: "0.75rem" }}>
                  Requiere presupuesto detallado?
                </Typography>
                <Select
                  native
                  name="budget_detailed"
                  id="budget_detailed"
                  inputProps={{
                    name: "budget_detailed",
                    id: "budget_detailed",
                    className: "budget_detailed"
                  }}
                  style={{ minWidth: 150, fontSize: "0.75rem" }}
                  disabled={disabled}
                  value={budget_detailed}
                  input={
                    <Input
                      id="grouped-native-select"
                      name="budget_detailed"
                      id="budget_detailed"
                    />
                  }
                >
                  <option value="" />
                  {budget_detailed_types.map(budget_detailed_types => (
                    <option
                      id={budget_detailed_types.id}
                      value={budget_detailed_types.id}
                    >
                      {budget_detailed_types.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <TextField
                id="budget_q"
                label="Cant. de presupuetos"
                disabled={disabled}
                margin="normal"
                className="mt-1"
                type="number"
                value={budget_q}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputLabelProps={{ shrink: true }}
              />
            </React.Fragment>
          ) : (
            ""
          )}
        </div>

        <Typography gutterBottom variant="h6">
          Detalle de la política
        </Typography>
        <Typography variant="caption">
          {tasks.map((val, idx) => {
            let taskId = `task_id-${idx}`,
              taskLabelId = `taskLabel-${idx}`,
              isSetId = `isSet-${idx}`,
              typeId = `typeId-${idx}`,
              valueId = `value-${idx}`,
              actionDetailId = `actionDetail-${idx}`;
            return (
              <div key={idx}>
                <Switch
                  id={`tasks-${isSetId}`}
                  value={tasks[idx].isSet}
                  checked={tasks[idx].isSet}
                  name={isSetId}
                  disabled={this.state.disabled}
                  size="small"
                  color="primary"
                  className="mt-4 mr-4"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                {tasks[idx].task_id === "" ? (
                  <DropdownTreeSelect
                    data={data}
                    onChange={e => this.setDropdownTask(`tasks-${taskId}`, e)}
                    mode="radioSelect"
                    className="mt-4"
                    texts={{ placeholder: "Buscar tareas" }}
                    style={{ display: "inline-block" }}
                  />
                ) : (
                  ""
                )}
                {tasks[idx].task_id !== "" ? (
                  <React.Fragment>
                    <Tooltip title={tasks[idx].taskLabel}>
                      <TextField
                        id={tasks[idx].task_id}
                        disabled
                        margin="normal"
                        className="mt-4"
                        value={tasks[idx].taskLabel}
                        InputProps={{
                          style: { width: "18rem", fontSize: "0.75rem" }
                        }}
                      />
                    </Tooltip>
                  </React.Fragment>
                ) : (
                  ""
                )}

                {tasks[idx].type === "month" ? (
                  <TextField
                    label="Meses"
                    type="number"
                    error={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : false
                    }
                    helperText={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : ""
                    }
                    disabled={this.state.disabled || !tasks[idx].isSet}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      style: { width: "5rem", fontSize: "0.75rem" }
                    }}
                    inputProps={{ min: 1 }}
                    name={valueId}
                    data-id={idx}
                    id={`tasks-${valueId}`}
                    value={tasks[idx].value}
                    className="ml-2 mr-2 mt-2"
                    margin="normal"
                  />
                ) : (
                  ""
                )}
                {tasks[idx].type === "km" ? (
                  <TextField
                    label="KM"
                    error={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : false
                    }
                    helperText={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : ""
                    }
                    disabled={this.state.disabled || !tasks[idx].isSet}
                    type="number"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      style: { width: "5rem", fontSize: "0.75rem" }
                    }}
                    inputProps={{ min: 1 }}
                    name={valueId}
                    data-id={idx}
                    id={`tasks-${valueId}`}
                    value={tasks[idx].value}
                    className="ml-2 mr-2 mt-2"
                    margin="normal"
                  />
                ) : (
                  ""
                )}

                {tasks[idx].type === "drowpDownEstacionamiento" ? (
                  <FormControl
                    error={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : false
                    }
                    helperText={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : ""
                    }
                    className="ml-2 mr-2 mt-2"
                    style={{ minWidth: 150, fontSize: "0.75rem" }}
                    name="drowpDownEstacionamiento"
                  >
                    <InputLabel
                      htmlFor="grouped-native-select"
                      style={{ minWidth: 150, fontSize: "0.75rem" }}
                    >
                      Seleccione
                    </InputLabel>
                    <Select
                      native
                      name="drowpDownEstacionamiento"
                      disabled={!tasks[idx].isSet || this.state.disabled}
                      inputProps={{
                        name: valueId,
                        dataid: idx,
                        id: `tasks-${valueId}`,
                        name: "drowpDownEstacionamiento",
                        className: "drowpDownEstacionamiento"
                      }}
                      style={{ minWidth: 150, fontSize: "0.75rem" }}
                      value={tasks[idx].value}
                      input={
                        <Input
                          id="grouped-native-select"
                          name="drowpDownEstacionamiento"
                        />
                      }
                    >
                      <option value="" />
                      <option value="empresa">Empresa</option>
                      <option value="particular">Particular</option>
                      <option value="tercerizado">Tercerizado</option>
                    </Select>
                  </FormControl>
                ) : (
                  ""
                )}

                {tasks[idx].type === "quantity" ? (
                  <TextField
                    label="Cantidad"
                    error={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : false
                    }
                    helperText={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : ""
                    }
                    disabled={this.state.disabled || !tasks[idx].isSet}
                    type="number"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      style: { width: "5rem", fontSize: "0.75rem" }
                    }}
                    inputProps={{ min: 1 }}
                    name={valueId}
                    data-id={idx}
                    id={`tasks-${valueId}`}
                    value={tasks[idx].value}
                    className="ml-2 mr-2 mt-2"
                    margin="normal"
                  />
                ) : (
                  ""
                )}

                {tasks[idx].type === "ammount" ? (
                  <TextField
                    label="Monto"
                    error={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : false
                    }
                    helperText={
                      tasks[idx].isSet === true && tasks[idx].value === ""
                        ? "Debe completar este valor"
                        : ""
                    }
                    disabled={this.state.disabled || !tasks[idx].isSet}
                    type="number"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      style: { width: "5rem", fontSize: "0.75rem" }
                    }}
                    inputProps={{ min: 1 }}
                    name={valueId}
                    data-id={idx}
                    id={`tasks-${valueId}`}
                    value={tasks[idx].value}
                    className="ml-2 mr-2 mt-2"
                    margin="normal"
                  />
                ) : (
                  ""
                )}
                <Tooltip title={tasks[idx].actionDetail} aria-label="add">
                  <TextField
                    label="Plan de acción"
                    type="text"
                    disabled={this.state.disabled || !tasks[idx].isSet}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      style: { width: "30rem", fontSize: "0.75rem" }
                    }}
                    name={actionDetailId}
                    data-id={idx}
                    id={`tasks-${actionDetailId}`}
                    value={tasks[idx].actionDetail}
                    className="m-2"
                    margin="normal"
                  />
                </Tooltip>
                {this.state.disabled === false ? (
                  <div
                    className="mt-4"
                    style={{ width: "min-content", display: "inline-flex" }}
                  >
                    <IconButton
                      size="small"
                      onClick={this.removeItem(idx)}
                      disabled={tasks.length == 1 ? true : false}
                    >
                      <RemoveIcon />
                    </IconButton>
                    {tasks.length === idx + 1 ? (
                      <IconButton size="small" onClick={this.addNewItem}>
                        <AddIcon />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
          <div className="row"></div>
          <Switch
            id="unexpected_situations"
            name="unexpected_situations"
            disabled={this.state.disabled || !this.state.unexpected_situations}
            value={this.state.unexpected_situations}
            checked={this.state.unexpected_situations}
            disabled={this.state.disabled}
            color="primary"
            size="small"
            className="mt-4 mr-4"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          <TextField
            disabled={true}
            value="Situaciones no previstas"
            type="text"
            InputLabelProps={{
              shrink: true
            }}
            className="mt-4"
            InputProps={{ style: { width: "10rem", fontSize: "0.75rem" } }}
            margin="normal"
          />
          <Tooltip title={unexpected_situations_action_detail} aria-label="add">
            <TextField
              label="Plan de accion"
              type="text"
              disabled={
                this.state.disabled || !this.state.unexpected_situations
              }
              name="unexpected_situations_action_detail"
              id="unexpected_situations_action_detail"
              InputLabelProps={{
                shrink: true
              }}
              value={unexpected_situations_action_detail}
              InputProps={{ style: { width: "30rem", fontSize: "0.75rem" } }}
              className="m-2"
              margin="normal"
            />
          </Tooltip>
        </Typography>
        <div className="row"></div>
        <div className="row"></div>
        {this.state.disabled === false ? (
          <div style={{ width: "30rem" }}>
            <DropzoneArea
              onChange={this.handleUpload.bind(this)}
              dropzoneText="Arrastra los archivos aquí o buscalos"
              showPreviews="true"
              showPreviewsInDropzone={false}
              showFileNamesInPreview="true"
              showFileNames="true"
            />
          </div>
        ) : (
          ""
        )}
        {media.length > 0 ? (
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre del archivo</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {media.map((val, idx) => (
                <TableRow key={val.id}>
                  <TableCell>{val.name}</TableCell>
                  <TableCell>
                    <Link href={api.media_download + "/" + val.id}>
                      <ArrowDownwardIcon />
                      Descargar
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          ""
        )}

        {this.state.action !== "view" ? (
          <div>
            <Button
              disabled={this.state.disabled_submit}
              type="submit"
              variant="contained"
              className="mt-3 ml-1 mr-1"
              color="primary"
            >
              Guardar
            </Button>
            <Button
              variant="contained"
              className="mt-3 ml-1 mr-1"
              color="secondary"
              href={"/policies?idContract=" + this.state.contract_id}
            >
              Cancelar
            </Button>
          </div>
        ) : (
          <div>
            <Button
              variant="contained"
              className="mt-3 ml-1 mr-1"
              color="secondary"
              href={"/policies?idContract=" + this.state.contract_id}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              className="mt-3 ml-1 mr-1"
              color="primary"
              onClick={this.handlePreview}
            >
              Previsualizar
            </Button>
            <Button
              className="mt-3 ml-1 mr-1"
              href={api.policy().export(this.state.policyId)}
              variant="contained"
              color="primary"
            >
              Descargar
            </Button>
          </div>
        )}
      </form>
    );
  }
}

export default PoliciesForm;
